import React from 'react';

export interface LuminosityAlertProps {
  level: 'low' | 'high' | 'optimal';
  message?: string;
  onDismiss?: () => void;
  className?: string;
}

const levelConfig = {
  low: {
    icon: 'wb_twilight',
    title: 'Luz insuficiente',
    defaultMessage: 'Aumente a iluminação ou use o flash para melhores resultados.',
    bgClass: 'bg-warning-bg',
    textClass: 'text-warning-text',
    iconBgClass: 'bg-warning-bg/70',
  },
  high: {
    icon: 'wb_sunny',
    title: 'Luz excessiva',
    defaultMessage: 'Reduza a exposição ou procure sombra para evitar áreas superexpostas.',
    bgClass: 'bg-warning-bg',
    textClass: 'text-warning-text',
    iconBgClass: 'bg-warning-bg/70',
  },
  optimal: {
    icon: 'check_circle',
    title: 'Iluminação ideal',
    defaultMessage: 'Condições de luz perfeitas para a captura.',
    bgClass: 'bg-success-bg',
    textClass: 'text-success-text',
    iconBgClass: 'bg-success-bg/70',
  },
};

export const LuminosityAlert: React.FC<LuminosityAlertProps> = ({
  level = 'optimal',
  message,
  onDismiss,
  className = '',
}) => {
  const config = levelConfig[level];

  if (level === 'optimal' && !message && !onDismiss) {
    return null;
  }

  return (
    <div
      className={`
        luminosity-alert ${config.bgClass} ${config.textClass}
        ${className}
      `}
      role="alert"
      aria-live="polite"
    >
      <div className={`luminosity-alert-icon ${config.iconBgClass}`}>
        <span className="material-symbols-outlined text-lg">{config.icon}</span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="luminosity-alert-title">{config.title}</p>
        <p className="luminosity-alert-message mt-1">
          {message || config.defaultMessage}
        </p>
      </div>
      {onDismiss && (
        <button
          type="button"
          onClick={onDismiss}
          className="btn btn-ghost p-1 -mr-2"
          aria-label="Dispensar aviso"
        >
          <span className="material-symbols-outlined">close</span>
        </button>
      )}
    </div>
  );
};